import React from 'react';
import { bool } from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';


const Settings = ({ isCreate = true }) => (
    <Section name="Settings">
        <FormField control={Checkbox} disabled={isCreate} toggle label="Portal" name="portal" />
        <FormField control={Checkbox} disabled toggle label="System Portal" name="superPortal" />

        <FormField control={Checkbox} toggle label="Deleted" name="deleted" />
        <FormField control={Checkbox} toggle label="Archived" name="archived" />
        <FormField control={Checkbox} toggle label="Private" name="private" />
        <FormField control={Checkbox} toggle label="Closed" name="closed" />
        <FormField control={Checkbox} toggle label="Enable share portals" name="enable_share_portal" />
    </Section>
);

Settings.propTypes = {
    isCreate: bool,
};

export default Settings;
